import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { green, red } from "@mui/material/colors";

const LoadingWithStatusOverlay = ({ status = "idle", message, onComplete, successTimeout = 3000, failureTimeout = 3000 }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (status !== "idle") {
            setVisible(true);
        }

        if (status === "success") {
            const timer = setTimeout(() => {
                setVisible(false);
                if (onComplete) onComplete();
            }, successTimeout);

            return () => clearTimeout(timer);
        } else if (status === "error") {
            const timer = setTimeout(() => {
                setVisible(false);
                if (onComplete) onComplete();
            }, failureTimeout);

            return () => clearTimeout(timer);
        }
    }, [status, onComplete]);

    if (!visible) return null;

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            position="fixed"
            top={0}
            left={0}
            width="100vw"
            height="100vh"
            zIndex={9999}
            bgcolor="rgba(255, 255, 255, 0.8)"
            sx={{ transition: "all 0.3s ease-in-out" }}
        >
            <Box position="relative" display="inline-flex">
                {status === "loading" && <CircularProgress size={68} thickness={4} />}

                {status === "success" && (
                    <>
                        <CircularProgress
                            variant="determinate"
                            value={100}
                            size={68}
                            thickness={4}
                            sx={{ color: green[500] }}
                        />
                        <Box
                            sx={{
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: "absolute",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <CheckIcon sx={{ color: green[500], fontSize: 40 }} />
                        </Box>
                    </>
                )}

                {status === "error" && (
                    <>
                        <CircularProgress
                            variant="determinate"
                            value={100}
                            size={68}
                            thickness={4}
                            sx={{ color: red[500] }}
                        />
                        <Box
                            sx={{
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: "absolute",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <CloseIcon sx={{ color: red[500], fontSize: 40 }} />
                        </Box>
                    </>
                )}
            </Box>

            {message && (
                <Box mt={2} fontWeight="medium" fontSize="1rem">
                    {message}
                </Box>
            )}
        </Box>
    );
};

export default LoadingWithStatusOverlay;